import type { RouteObject } from 'react-router-dom'
import { useRoutes } from 'react-router-dom'
import Layout from '@/components/Layout'
import Home from '@/pages/Home'
import EmergencyPage from '@/pages/EmergencyPage'
import MaintenancePage from '@/pages/MaintenancePage'
import InstallationsPage from '@/pages/InstallationsPage'
import AboutPage from '@/pages/AboutPage'
import ZonesPage from '@/pages/ZonesPage'
import ZoneDetailPage from '@/pages/ZoneDetailPage'
import ContactPage from '@/pages/ContactPage'
import { MentionsLegales, Confidentialite, CGV } from '@/pages/LegalPages'
import NotFound from '@/pages/NotFound'

// Used in @/prerender.tsx
export const routes: RouteObject[] = [
  {
    path: '/',
    element: <Layout />,
    children: [
      { index: true, element: <Home /> },
      { path: 'depannage-urgence', element: <EmergencyPage /> },
      { path: 'entretien', element: <MaintenancePage /> },
      { path: 'installations', element: <InstallationsPage /> },
      { path: 'a-propos', element: <AboutPage /> },
      { path: 'zones-intervention', element: <ZonesPage /> },
      { path: 'zones/:slug', element: <ZoneDetailPage /> },
      { path: 'contact', element: <ContactPage /> },
      { path: 'mentions-legales', element: <MentionsLegales /> },
      { path: 'confidentialite', element: <Confidentialite /> },
      { path: 'cgv', element: <CGV /> },
      { path: '*', element: <NotFound /> },
    ],
  },
]

function App() {
  return useRoutes(routes)
}

export default App
